<!-- Absolute background  currPoint.banner_original -->
<div class="pos-img-cov absolute-bg patternBG"
     [ngStyle]="(currPoint && currPoint.bannerUrl) ? {'background-image': 'url(' + ((currPoint.bannerUrl | prodSizeFilter: 1024)) + ')'} : null">
</div>

<div style="z-index: 99;" [style.padding-top.px]="isProd ? 0 : devBannerHeightPx" class="relative h-full flex flex-col" *ngIf="!loader">

    <!-- Header  -->
    <app-header-order [redirectPage]="'product'" [openedSaleMethodDial]="true"
                      (closeSaleMethodDialEvent)="closeDial()" >
    </app-header-order>

    <div class="flex-1 scrolled flex flex-col p-6">

      <div class="px-4 flex flex-col text-center items-center gap-2 mb-4">
        <img src="{{ currPoint.img }}" *ngIf="currPoint.img"
             class="w-24 h-24 object-cover rounded-full " />
        <h2 class="text-2xl main-title-font text-white mt-6">{{ currPoint.denomination }}</h2>
        <p class="text-sm text-gray-100">{{ currPoint.address | capitalize }},
          {{ currPoint.postal }}
          {{ currPoint.city | uppercase }}</p>
      </div>

      <!-- Welcome title && Booking part  -->
      <div class="flex flex-col items-center justify-center w-full">

        <!-- Booking part  -->
        <button [ngClass]="cssService.defaultActionSMButton" class="sm:w-[400px] text-white bg-indigo-500 h-12"
                (click)="goBooking()" angulartics2On="click" angularticsAction="goBooking"
                angularticsCategory="saleMethods"
                *ngIf="bookingSettings">
          <div class="flex justify-between items-center">
            <div class="flex items-start gap-4 items-center">
              <!-- Icône Material -->
              <i class="material-icons text-md text-indigo-100">today</i>
              <!-- Texte -->
              <div>
                <h3 class="text-sm font-semibold">{{'smComponent.booking' |translate | uppercase}}</h3>
              </div>
            </div>
            <!-- Flèche droite -->
            <i class="material-icons text-gray-100">chevron_right</i>
          </div>
        </button>

      </div>

      <!-- Sale methods part  -->
      <div class="flex flex-col items-center justify-center w-full mt-4">

        <div class="mb-6 flex text-center">
          <span class="text-xl sm:text-2xl main-title-font whited-ico">{{"dialogs.sale-method.choose-sm-ws" | translate}}</span>
        </div>

        <div *ngFor="let sm of saleMethods$" class="w-full sm:w-[400px]">

          <!-- Bouton -->
          <button [ngClass]="cssService.defaultActionSMButton" class="bg-white hover:bg-gray-200 border-gray-300 "
                  (click)="selectSM(sm)"
                  angulartics2On="click" angularticsAction="selecteSaleMethod" angularticsCategory="saleMethods"
                  [class.blured]="currSmId && currSmId === sm.id " *ngIf="sm.webshop_visible === 1"
                  [class.disablured]="sm.notavailable" [class.clicked]="!sm.notavailable">

            <div class="flex flex-row items-center">

              <div class="flex-1 flex flex-col gap-1">
                <h3 class="text-md font-semibold text-gray-800">{{sm.name | uppercase}}</h3>

                <div class="text-xs text-gray-700 flex flex-row gap-2.5 text-center" *ngIf="sm.enable_date_hour">

                  <mat-spinner diameter="20" *ngIf="!sm.slotOpen"></mat-spinner>

                  <div *ngIf="sm.notavailable" class="warn-ico boldest">{{'smComponent.unavailable'|translate}}</div>

                  <div
                    *ngIf="sm.slotOpen && (sm.slotOpen.day ||sm.slotOpen.hour) ">{{'smComponent.nexttime'|translate}} </div>

                  <div
                    *ngIf="sm.slotOpen && sm.slotOpen.day &&!sm.slotOpen.sameday ">{{sm.slotOpen.day | dateFilter:"dddd DD/MM/YY"}}</div>

                  <div *ngIf="sm.slotOpen && sm.slotOpen.hour && sm.slotOpen.sameday">{{sm.slotOpen.hour}}</div>

                </div>

              </div>
              <i class="material-icons w-5 h-5 text-gray-400">chevron_right</i>
            </div>
          </button>
        </div>

      </div>

    </div>

    <!-- Footer  -->
    <app-powered-fulle></app-powered-fulle>

</div>
<app-fulle-page-loader [loader]="loader" [pointOfSale]="currPoint" class="h-full"></app-fulle-page-loader>
